"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _People = _interopRequireDefault(require("@insided/destination/icons/People"));

var TopicPreviewNotice = function TopicPreviewNotice(_ref) {
  var isPreviewPublic = _ref.isPreviewPublic;
  var noticeText = isPreviewPublic ? 'Anyone who has the link can access preview via the link without signing in' : 'Only people with moderator role or above can access this page via the link';
  return (0, _preact.h)("div", {
    className: "box"
  }, (0, _preact.h)("div", {
    className: "topic-preview__notice"
  }, (0, _preact.h)("div", {
    className: "topic-preview__notice-label h3"
  }, "Preview"), (0, _preact.h)("div", {
    className: "topic-preview__notice-desc"
  }, (0, _preact.h)("div", {
    className: "topic-preview__notice-icon"
  }, (0, _preact.h)(_People.default, {
    height: 16,
    width: 15,
    fill: "#6B707E"
  })), (0, _preact.h)("div", {
    className: "topic-preview__notice-text"
  }, noticeText))));
};

var _default = TopicPreviewNotice;
exports.default = _default;